export const inventoryData = [
  {
    id: 1,
    name: "iPhone 14 Pro",
    sku: "IPH14P-128-BLK",
    image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=100&h=100&fit=crop",
    currentStock: 45,
    reorderLevel: 10,
    status: "In Stock"
  },
  {
    id: 2,
    name: "Samsung Galaxy S23",
    sku: "SGS23-256-WHT",
    image: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=100&h=100&fit=crop",
    currentStock: 8,
    reorderLevel: 15,
    status: "Low Stock"
  },
  {
    id: 3,
    name: "MacBook Pro 16\"",
    sku: "MBP16-512-SLV",
    image: "https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=100&h=100&fit=crop",
    currentStock: 0,
    reorderLevel: 5,
    status: "Out of Stock"
  },
  {
    id: 4,
    name: "AirPods Pro",
    sku: "APP-GEN2-WHT",
    image: "https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=100&h=100&fit=crop",
    currentStock: 120,
    reorderLevel: 25,
    status: "In Stock"
  },
  {
    id: 5,
    name: "iPad Air",
    sku: "IPA-64-BLU",
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=100&h=100&fit=crop",
    currentStock: 12,
    reorderLevel: 20,
    status: "Low Stock"
  },
  {
    id: 6,
    name: "Apple Watch Series 8",
    sku: "AWS8-45-BLK",
    image: "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=100&h=100&fit=crop",
    currentStock: 67,
    reorderLevel: 15,
    status: "In Stock"
  },
  {
    id: 7,
    name: "Sony WH-1000XM4",
    sku: "SWH1000-BLK",
    image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=100&h=100&fit=crop",
    currentStock: 3,
    reorderLevel: 10,
    status: "Low Stock"
  },
  {
    id: 8,
    name: "Nintendo Switch",
    sku: "NSW-OLED-RED",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=100&h=100&fit=crop",
    currentStock: 89,
    reorderLevel: 20,
    status: "In Stock"
  }
];

export const stockHistory = [
  {
    id: 1,
    productId: 1,
    action: "Added",
    quantity: 50,
    date: "2024-01-15",
    reason: "New shipment"
  },
  {
    id: 2,
    productId: 2,
    action: "Sold",
    quantity: -7,
    date: "2024-01-14",
    reason: "Customer orders"
  },
  {
    id: 3,
    productId: 3,
    action: "Sold",
    quantity: -2,
    date: "2024-01-13",
    reason: "Customer orders"
  }
];